import React, { memo, useMemo, useState } from 'react'
import styled, { css } from 'styled-components'
import { Dropdown, SwitchTabs } from '@ui-library/core'
import { StyledSectionContainer, SecondaryTitle, ModuleContentContainer } from '../shared/section'
import { colors } from '../../../utils/helpers/colors'
import LinkList from '../shared/LinkList'

const capitalize = word => word.charAt(0).toUpperCase() + word.substring(1)
const spaceWords = str => str.replace(/-/g, ' ')
const adNumbers = nbAds => (nbAds === undefined || nbAds === null || nbAds === 0 ? '' : ` (${nbAds} annonces)`)

const LinkBoxCategory = styled.div`
  ${props =>
    !props.isSelected &&
    css`
      display: none;
    `}
`

const DropdownContainer = styled.div`
  margin-bottom: 8px;

  &:first-child {
    &:first-child {
      width: fit-content;
    }
  }
`

const SwitchTabsContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  overflow-y: auto;

  &:before {
    content: '';
    position: absolute;
    height: 1px;
    border-radius: 2px;
    background-color: ${colors.gallery};
    bottom: 0;
    width: 100%;
  }
`

const MobileView = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`

const DesktopView = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`

const LinkBoxLinksList = ({ isSelected, links }) => (
  <LinkBoxCategory {...{ isSelected }}>
    <LinkList
      links={links.map(link => ({
        text: link.text,
        url: link.url,
      }))}
      maxLinks={10}
      wording={{ plural: 'liens' }}
    />
  </LinkBoxCategory>
)

const LinkBoxTabsContainer = ({ isSelected, realEstateTypeLinkBoxes }) => {
  const realEstateTypes = useMemo(
    () => realEstateTypeLinkBoxes.map(ret => ({ label: spaceWords(capitalize(ret.description)), id: ret.realEstateTypeId, ariaControls: `panel-${ret.realEstateTypeId}` })),
    [realEstateTypeLinkBoxes],
  )
  const [currentRealEstateType, setCurrentRealEstateType] = useState(realEstateTypes[0])

  return (
    <LinkBoxCategory {...{ isSelected }}>
      <SwitchTabsContainer>
        <MobileView>
          <SwitchTabs kind="secondary" type="scrollable" choices={realEstateTypes} size={130} selected={`tab-${currentRealEstateType.id}`} onChange={setCurrentRealEstateType} />
        </MobileView>
        <DesktopView>
          <SwitchTabs kind="secondary" type="normal" choices={realEstateTypes} selected={`tab-${currentRealEstateType.id}`} onChange={setCurrentRealEstateType} />
        </DesktopView>
      </SwitchTabsContainer>
      {realEstateTypeLinkBoxes.map(group => (
        <LinkBoxLinksList
          key={realEstateTypeLinkBoxes.indexOf(group)}
          links={group.links.map(link => ({ text: spaceWords(capitalize(link.text)) + adNumbers(link.adsCount), url: link.url }))}
          isSelected={group.realEstateTypeId === currentRealEstateType.id}
        />
      ))}
    </LinkBoxCategory>
  )
}

const LinkBoxSeLogerModule = ({ transactionTypeLinkboxGroups }) => {
  const transactionsTypes = useMemo(() => transactionTypeLinkboxGroups.map(tt => ({ label: `Les annonces pour ${tt.text}`, value: { result: tt.transactionTypeId } })), [
    transactionTypeLinkboxGroups,
  ])
  const [currentTransactionType, setCurrentTransactionType] = useState(transactionsTypes[0].value)

  return (
    <StyledSectionContainer backgroundColor={colors.white} data-testid="section-container-pp">
      <SecondaryTitle data-testid="secondary-title-pp">
        Les <b>annonces immobili&egrave;res</b>
      </SecondaryTitle>
      <ModuleContentContainer data-testid="module-content-pp">
        <DropdownContainer>
          <Dropdown value={currentTransactionType} list={transactionsTypes} onSelect={setCurrentTransactionType} />
        </DropdownContainer>
        {transactionTypeLinkboxGroups.map(group => (
          <LinkBoxTabsContainer
            key={group.transactionTypeId}
            isSelected={group.transactionTypeId === currentTransactionType.result}
            realEstateTypeLinkBoxes={group.realEstateTypeLinkBoxes}
          />
        ))}
      </ModuleContentContainer>
    </StyledSectionContainer>
  )
}

export default memo(LinkBoxSeLogerModule)
